import {ErrorHandler, Injectable} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import * as Sentry from '@sentry/angular';
import {isIdleLockError} from '../auth/models/web-session.util';

/**
 * Custom ErrorHandler that delegates to Sentry but skips HTTP errors
 * which are already captured by the ErrorInterceptor.
 * Without this, every HTTP error is reported twice.
 */
@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  private sentryHandler = Sentry.createErrorHandler({showDialog: false});

  handleError(error: any): void {
    // Angular wraps unhandled promise rejections in { rejection: ... }
    const extracted = error?.rejection ?? error;

    // Skip string errors — these are HTTP error messages re-thrown by ErrorInterceptor
    if (typeof extracted === 'string') return;

    // Skip HttpErrorResponse — also already captured by ErrorInterceptor
    if (extracted instanceof HttpErrorResponse) return;

    // JS-1396 idle-lock 423: expected, the unlock screen handles it
    if (isIdleLockError(extracted)) return;

    this.sentryHandler.handleError(error);
  }
}
